export function money(value, currency = "ARS") {
  try {
    return new Intl.NumberFormat("es-AR", {
      style: "currency",
      currency,
      maximumFractionDigits: currency === "ARS" ? 0 : 2,
    }).format(Number(value || 0));
  } catch {
    return `${currency} ${Number(value || 0).toLocaleString("es-AR")}`;
  }
}

export function dateTime(value) {
  if (!value) return "Sin fecha";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "Sin fecha";
  return new Intl.DateTimeFormat("es-AR", {
    day: "2-digit",
    month: "short",
    hour: "2-digit",
    minute: "2-digit",
  }).format(date);
}

export function relativeDate(value) {
  if (!value) return "Sin seguimiento";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "Sin seguimiento";
  const now = new Date();
  const deltaDays = Math.round((date.getTime() - now.getTime()) / 86400000);
  if (deltaDays < -1) return `Vencido hace ${Math.abs(deltaDays)} días`;
  if (deltaDays === -1) return "Venció ayer";
  if (deltaDays === 0) return "Hoy";
  if (deltaDays === 1) return "Mañana";
  if (deltaDays <= 7) return `En ${deltaDays} días`;
  return dateTime(value);
}

export function dateInputValue(value) {
  if (!value) return "";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  const pad = (number) => String(number).padStart(2, "0");
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
}

export const surfaceSx = {
  borderRadius: 3.2,
  border: "1px solid rgba(var(--wp-panel-ink-rgb,25,36,47),.085)",
  bgcolor: "var(--wp-panel-surface, #fff)",
  boxShadow: "0 12px 36px rgba(var(--wp-panel-shadow-rgb,25,36,47),.045)",
};

export const insetSx = {
  borderRadius: 2.3,
  bgcolor: "rgba(var(--wp-panel-ink-rgb,25,36,47),.035)",
  border: "1px solid rgba(var(--wp-panel-ink-rgb,25,36,47),.055)",
};

export const compactActionSx = {
  textTransform: "none",
  fontWeight: 900,
  borderRadius: 2,
};
